import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// Assuming you set your logo text in an environment variable
const LOGO_TEXT = process.env.REACT_APP_LOGO_TEXT || '';

// Updated size map with smaller mobile sizes
const sizeMap = {
  small: { 
    height: 28,           
    mobileHeight: 24,     
    textSize: '0.8rem',   
    mobileTextSize: '0.7rem'
  },
  medium: { 
    height: 38,           
    mobileHeight: 30,     
    textSize: '1.1rem',   
    mobileTextSize: '0.85rem'
  },
  large: { 
    height: 45,           
    mobileHeight: 36,     
    textSize: '1.3rem',   
    mobileTextSize: '0.95rem'
  },
};

const LogoSection = ({
  variant = 'default',
  size = 'medium',
  showText = true,
  showImage = true,
  linkTo = '/',
  src = '/logo.jpg',
  sx = {},
  imageSx = {},
  textSx = {},
  component: Component = RouterLink,
  ...rest
}) => {
  const dimensions = sizeMap[size] || sizeMap.medium;

  const getTextStyles = () => {
    if (variant === 'white') {
      return {
        color: '#ffffff',
        fontWeight: 700,
        letterSpacing: '0.5px',
      };
    }
    if (variant === 'admin') {
      return {
        color: '#1A3365',
        fontWeight: 700,
        letterSpacing: '-0.5px',
      };
    }
    return {
      fontWeight: 800,
      color: '#E6A817',
      letterSpacing: '0.04em',
    };
  };

  const isWhiteVariant = variant === 'white' || variant === 'admin';
  const effectiveImageSx = {
    ...(isWhiteVariant && {
      filter: 'brightness(0) invert(1)',
    }),
    ...imageSx,
  };

  return (
    <Box
      component={Component}
      to={linkTo}
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        gap: { xs: 0.8, sm: 1.2, md: 1.5 },
        ...sx,
      }}
      {...rest}
    >
      {showImage && (
        <Box
          component="img"
          src={src}
          alt="Travel Agency Logo"
          sx={{
            height: {
              xs: dimensions.mobileHeight || dimensions.height,
              sm: dimensions.height,
            },
            width: 'auto',
            maxWidth: { xs: 120, sm: 150, md: 170 },
            objectFit: 'contain',
            borderRadius: 1,
            flexShrink: 0,    // prevent image from shrinking
            transition: 'transform 0.3s ease',
            '&:hover': {
              transform: 'scale(1.02)',
            },
            ...effectiveImageSx,
          }}
        />
      )}
      {showText && LOGO_TEXT && (
        <Typography
          variant={size === 'small' ? 'subtitle1' : 'h5'}
          sx={{
            fontSize: {
              xs: dimensions.mobileTextSize || dimensions.textSize,
              sm: dimensions.textSize,
            },
            whiteSpace: 'nowrap',   // keeps text on one line
            flexShrink: 0,          // prevents text from being cut
            ...getTextStyles(),
            ...textSx,
          }}
        >
          {LOGO_TEXT}
        </Typography>
      )}
    </Box>
  );
};

export default LogoSection;